// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeRedblue = {
  redbluePlatformDataContractInvalid: "RedBlue 平台数据合同无效：{field_name}，{reason}",
  redblueBusinessEventInboxRetryLater: "RedBlue 业务事件正在处理中，请稍后按原事件重试",
  redblueBusinessEventUnexpectedRetryableFailure:
    "RedBlue 业务事件遇到临时依赖故障，将按原事件重试",
} as const;
